import { useEventListener } from "@redotech/react-util/event";
import { useHandler } from "@redotech/react-util/hook";
import { Location, unstable_useBlocker } from "react-router-dom";

export function isPathAtOrBelow(pathname: string, prefix: string) {
  const normalizedPrefix =
    prefix.length > 1 && prefix.endsWith("/") ? prefix.slice(0, -1) : prefix;

  return normalizedPrefix === "/"
    ? pathname.startsWith(normalizedPrefix)
    : pathname === normalizedPrefix ||
        pathname.startsWith(`${normalizedPrefix}/`);
}

export function usePrompt(
  message: string | null,
  blockQueryChanges = true,
  /** Navigation that stays under this path keeps the form mounted, so it is
   *  not leaving and must not prompt. */
  samePagePathPrefix?: string,
) {
  unstable_useBlocker(
    useHandler(
      ({
        currentLocation,
        nextLocation,
      }: {
        currentLocation: Location;
        nextLocation: Location;
      }) => {
        if (message == null) {
          return false;
        }
        if (
          samePagePathPrefix !== undefined &&
          isPathAtOrBelow(currentLocation.pathname, samePagePathPrefix) &&
          isPathAtOrBelow(nextLocation.pathname, samePagePathPrefix)
        ) {
          return false;
        }
        if (
          !blockQueryChanges &&
          currentLocation.pathname === nextLocation.pathname &&
          currentLocation.hash === nextLocation.hash
        ) {
          return false;
        }

        return !confirm(message);
      },
    ),
  );

  useEventListener(message !== null ? window : null, "beforeunload", (e) => {
    e.preventDefault();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=866818
    e.returnValue = true;
  });

  // useEffect(() => {
  //   if (blocker.state === "blocked") {
  //     blocker.reset();
  //   }
  // }, [blocker]);
}
